<script>
import forminput from "../formcomponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import website from "@/models/website";
import formcombobox from "../formcomponet/formcombobox.vue"; 

export default {
  mixins: [apibtoast, apigeneric, website],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {}, 
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox, 
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("website", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("website");
            }
          });
        } else {
          this.Update("website", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("website");
            }
          });
        }
      }
    },
    Get() {
      
    },
 
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="website"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('website.AddEdit.FormTitleEdit')
          : $t('website.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
     
          <Form @submit.prevent="onSubmit"> 
            <div class="row">
              <div class="col-md-12">
                <forminput
                  :FormDataType="FormDataType.Siteadi"
                  :Value="FormData.Siteadi"
                  :v="$v.FormData.Siteadi"
                  @input="FormData.Siteadi = $event"
                  :min="0"
                  :max="999"
                />
              </div>
              <div class="col-md-12">
                <formcombobox
                  :FormDataType="FormDataType.Tip"
                  :Value="FormData.Tip"
                  :v="$v.FormData.Tip"
                  @input="FormData.Tip = $event"
                />
              </div>
              <div class="col-md-12">
                <forminput
                  :FormDataType="FormDataType.Url"
                  :Value="FormData.Url"
                  :v="$v.FormData.Url"
                  @input="FormData.Url = $event"
                />
              </div>
              <div class="col-md-12">
                <forminput
                  :FormDataType="FormDataType.Adminurl"
                  :Value="FormData.Adminurl"
                  :v="$v.FormData.Adminurl"
                  @input="FormData.Adminurl = $event"
                />
              </div>
               
            </div>
         

            <button class="btn btn-primary" type="submit">
              {{ $t("website.AddEdit.Button") }}
            </button>
          </Form> 
         
    </b-modal>
  </Loader>
</template>
